export default {
    "AF": {
        "name": "Afganistan"
    },
    "AL": {
        "name": "Albania"
    },
    "DZ": {
        "name": "Algieria"
    },
    "AD": {
        "name": "Andora"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antigua i Barbuda"
    },
    "SA": {
        "name": "Arabia Saudyjska"
    },
    "AR": {
        "name": "Argentyna"
    },
    "AM": {
        "name": "Armenia"
    },
    "AU": {
        "name": "Australia"
    },
    "AT": {
        "name": "Austria"
    },
    "AZ": {
        "name": "Azerbejdżan"
    },
    "BS": {
        "name": "Bahamy"
    },
    "BH": {
        "name": "Bahrajn"
    },
    "BD": {
        "name": "Bangladesz"
    },
    "BB": {
        "name": "Barbados"
    },
    "BE": {
        "name": "Belgia"
    },
    "BZ": {
        "name": "Belize"
    },
    "BJ": {
        "name": "Benin"
    },
    "BT": {
        "name": "Bhutan"
    },
    "BY": {
        "name": "Białoruś"
    },
    "BO": {
        "name": "Boliwia"
    },
    "BA": {
        "name": "Bośnia i Hercegowina"
    },
    "BW": {
        "name": "Botswana"
    },
    "BR": {
        "name": "Brazylia"
    },
    "BN": {
        "name": "Brunei"
    },
    "BG": {
        "name": "Bułgaria"
    },
    "BF": {
        "name": "Burkina Faso"
    },
    "BI": {
        "name": "Burundi"
    },
    "CL": {
        "name": "Chile"
    },
    "CN": {
        "name": "Chiny"
    },
    "HR": {
        "name": "Chorwacja"
    },
    "CY": {
        "name": "Cypr"
    },
    "TD": {
        "name": "Czad"
    },
    "ME": {
        "name": "Czarnogóra"
    },
    "CZ": {
        "name": "Czechy"
    },
    "DK": {
        "name": "Dania"
    },
    "CD": {
        "name": "Demokratyczna Republika Konga"
    },
    "DM": {
        "name": "Dominika"
    },
    "DO": {
        "name": "Dominikana"
    },
    "DJ": {
        "name": "Dżibuti"
    },
    "EG": {
        "name": "Egipt"
    },
    "EC": {
        "name": "Ekwador"
    },
    "ER": {
        "name": "Erytrea"
    },
    "EE": {
        "name": "Estonia"
    },
    "SZ": {
        "name": "Eswatini"
    },
    "ET": {
        "name": "Etiopia"
    },
    "FJ": {
        "name": "Fidżi"
    },
    "PH": {
        "name": "Filipiny"
    },
    "FI": {
        "name": "Finlandia"
    },
    "FR": {
        "name": "Francja"
    },
    "GA": {
        "name": "Gabon"
    },
    "GM": {
        "name": "Gambia"
    },
    "GH": {
        "name": "Ghana"
    },
    "GR": {
        "name": "Grecja"
    },
    "GD": {
        "name": "Grenada"
    },
    "GE": {
        "name": "Gruzja"
    },
    "GY": {
        "name": "Gujana"
    },
    "GT": {
        "name": "Gwatemala"
    },
    "GW": {
        "name": "Gwinea Bissau"
    },
    "GQ": {
        "name": "Gwinea Równikowa"
    },
    "GN": {
        "name": "Gwinea"
    },
    "HT": {
        "name": "Haiti"
    },
    "ES": {
        "name": "Hiszpania"
    },
    "NL": {
        "name": "Holandia"
    },
    "HN": {
        "name": "Honduras"
    },
    "IN": {
        "name": "Indie"
    },
    "ID": {
        "name": "Indonezja"
    },
    "IQ": {
        "name": "Irak"
    },
    "IR": {
        "name": "Iran"
    },
    "IE": {
        "name": "Irlandia"
    },
    "IS": {
        "name": "Islandia"
    },
    "IL": {
        "name": "Izrael"
    },
    "JM": {
        "name": "Jamajka"
    },
    "JP": {
        "name": "Japonia"
    },
    "YE": {
        "name": "Jemen"
    },
    "JO": {
        "name": "Jordania"
    },
    "KH": {
        "name": "Kambodża"
    },
    "CM": {
        "name": "Kamerun"
    },
    "CA": {
        "name": "Kanada"
    },
    "QA": {
        "name": "Katar"
    },
    "KZ": {
        "name": "Kazachstan"
    },
    "KE": {
        "name": "Kenia"
    },
    "KG": {
        "name": "Kirgistan"
    },
    "KI": {
        "name": "Kiribati"
    },
    "CO": {
        "name": "Kolumbia"
    },
    "KM": {
        "name": "Komory"
    },
    "CG": {
        "name": "Kongo"
    },
    "KR": {
        "name": "Korea Południowa"
    },
    "KP": {
        "name": "Korea Północna"
    },
    "CR": {
        "name": "Kostaryka"
    },
    "CU": {
        "name": "Kuba"
    },
    "KW": {
        "name": "Kuwejt"
    },
    "LA": {
        "name": "Laos"
    },
    "LS": {
        "name": "Lesotho"
    },
    "LB": {
        "name": "Liban"
    },
    "LR": {
        "name": "Liberia"
    },
    "LY": {
        "name": "Libia"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LT": {
        "name": "Litwa"
    },
    "LU": {
        "name": "Luksemburg"
    },
    "LV": {
        "name": "Łotwa"
    },
    "MK": {
        "name": "Macedonia Północna"
    },
    "MG": {
        "name": "Madagaskar"
    },
    "MW": {
        "name": "Malawi"
    },
    "MV": {
        "name": "Malediwy"
    },
    "MY": {
        "name": "Malezja"
    },
    "ML": {
        "name": "Mali"
    },
    "MT": {
        "name": "Malta"
    },
    "MA": {
        "name": "Maroko"
    },
    "MR": {
        "name": "Mauretania"
    },
    "MU": {
        "name": "Mauritius"
    },
    "MX": {
        "name": "Meksyk"
    },
    "FM": {
        "name": "Mikronezja"
    },
    "MM": {
        "name": "Mjanma"
    },
    "MD": {
        "name": "Mołdawia"
    },
    "MC": {
        "name": "Monako"
    },
    "MN": {
        "name": "Mongolia"
    },
    "MZ": {
        "name": "Mozambik"
    },
    "NA": {
        "name": "Namibia"
    },
    "NR": {
        "name": "Nauru"
    },
    "NP": {
        "name": "Nepal"
    },
    "DE": {
        "name": "Niemcy"
    },
    "NE": {
        "name": "Niger"
    },
    "NG": {
        "name": "Nigeria"
    },
    "NI": {
        "name": "Nikaragua"
    },
    "NO": {
        "name": "Norwegia"
    },
    "NZ": {
        "name": "Nowa Zelandia"
    },
    "OM": {
        "name": "Oman"
    },
    "PK": {
        "name": "Pakistan"
    },
    "PW": {
        "name": "Palau"
    },
    "PA": {
        "name": "Panama"
    },
    "PG": {
        "name": "Papua-Nowa Gwinea"
    },
    "PY": {
        "name": "Paragwaj"
    },
    "PE": {
        "name": "Peru"
    },
    "PL": {
        "name": "Polska"
    },
    "PT": {
        "name": "Portugalia"
    },
    "ZA": {
        "name": "Południowa Afryka"
    },
    "CF": {
        "name": "Republika Środkowoafrykańska"
    },
    "CV": {
        "name": "Republika Zielonego Przylądka"
    },
    "RU": {
        "name": "Rosja"
    },
    "RO": {
        "name": "Rumunia"
    },
    "RW": {
        "name": "Rwanda"
    },
    "KN": {
        "name": "Saint Kitts i Nevis"
    },
    "LC": {
        "name": "Saint Lucia"
    },
    "VC": {
        "name": "Saint Vincent i Grenadyny"
    },
    "SV": {
        "name": "Salwador"
    },
    "WS": {
        "name": "Samoa"
    },
    "SM": {
        "name": "San Marino"
    },
    "SN": {
        "name": "Senegal"
    },
    "RS": {
        "name": "Serbia"
    },
    "SC": {
        "name": "Seszele"
    },
    "SL": {
        "name": "Sierra Leone"
    },
    "SG": {
        "name": "Singapur"
    },
    "SK": {
        "name": "Słowacja"
    },
    "SI": {
        "name": "Słowenia"
    },
    "SO": {
        "name": "Somalia"
    },
    "LK": {
        "name": "Sri Lanka"
    },
    "US": {
        "name": "Stany Zjednoczone"
    },
    "SD": {
        "name": "Sudan"
    },
    "SS": {
        "name": "Sudan Południowy"
    },
    "SR": {
        "name": "Surinam"
    },
    "SY": {
        "name": "Syria"
    },
    "CH": {
        "name": "Szwajcaria"
    },
    "SE": {
        "name": "Szwecja"
    },
    "TJ": {
        "name": "Tadżykistan"
    },
    "TH": {
        "name": "Tajlandia"
    },
    "TZ": {
        "name": "Tanzania"
    },
    "TL": {
        "name": "Timor Wschodni"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TT": {
        "name": "Trynidad i Tobago"
    },
    "TN": {
        "name": "Tunezja"
    },
    "TR": {
        "name": "Turcja"
    },
    "TM": {
        "name": "Turkmenistan"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "UG": {
        "name": "Uganda"
    },
    "UA": {
        "name": "Ukraina"
    },
    "UY": {
        "name": "Urugwaj"
    },
    "UZ": {
        "name": "Uzbekistan"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Wenezuela"
    },
    "HU": {
        "name": "Węgry"
    },
    "GB": {
        "name": "Wielka Brytania"
    },
    "VN": {
        "name": "Wietnam"
    },
    "IT": {
        "name": "Włochy"
    },
    "CI": {
        "name": "Wybrzeże Kości Słoniowej"
    },
    "MH": {
        "name": "Wyspy Marshalla"
    },
    "SB": {
        "name": "Wyspy Salomona"
    },
    "ST": {
        "name": "Wyspy Świętego Tomasza i Książęca"
    },
    "ZM": {
        "name": "Zambia"
    },
    "ZW": {
        "name": "Zimbabwe"
    },
    "AE": {
        "name": "Zjednoczone Emiraty Arabskie"
    }
}